const routes = [
    //钢铁
    {
        path: 'steel',
        name: '钢铁',
        component: () => import('@/views/steel/index'),
    },
    {
        path: 'steel/twoPage/enterprise',
        name: '钢铁重点企业资讯二级页',
        component: () => import('@/views/steel/twoPage/enterprise')
    },
    {
        path: 'steel/enterprise',
        name: '钢铁重点企业资讯详情页',
        component: () => import('@/views/steel/detail/enterprise')
    },
    {
        path: 'steel/twoPage/industry',
        name: '钢材行业动态二级页',
        component: () => import('@/views/steel/twoPage/industry')
    },
    {
        path: 'steel/industry',
        name: '钢材行业动态详情页',
        component: () => import('@/views/steel/detail/industry')
    },
    {
        path: 'steel/twoPage/price',
        name: '钢材价格二级页',
        component: () => import('@/views/steel/twoPage/price')
    },
    {
        path: 'steel/price',
        name: '钢材价格详情页',
        component: () => import('@/views/steel/detail/priceIndex')
    },
    {
        path: 'steel/twoPage/stock',
        name: '钢材库存二级页',
        component: () => import('@/views/steel/twoPage/stock')
    },
    {
        path: 'steel/stock',
        name: '钢材库存详情页',
        component: () => import('@/views/steel/detail/stock')
    },
    {
        path: 'steel/twoPage/exit',
        name: '钢材进出口量二级页',
        component: () => import('@/views/steel/twoPage/exit')
    },
    {
        path: 'steel/exit',
        name: '钢材进出口量详情页',
        component: () => import('@/views/steel/detail/exit')
    },
    {
        path: 'steel/twoPage/yield',
        name: '钢材产量二级页',
        component: () => import('@/views/steel/twoPage/yield')
    },
    {
        path: 'steel/yield',
        name: '钢材产量详情页',
        component: () => import('@/views/steel/detail/yield')
    },
    {
        path: 'steel/twoPage/report',
        name: '钢材行业报告二级页',
        component: () => import('@/views/steel/twoPage/report')
    },
    {
        path: 'steel/twoPage/standard',
        name: '钢材行业标准二级页',
        component: () => import('@/views/steel/twoPage/standard')
    },
    {
        path: 'steel/forecast',
        name: '钢铁价格预测详情页',
        component: () => import('@/views/steel/detail/forecast')
    },
    {
        path: 'steel/twoPage/forecast',
        name: '钢铁价格预测二级页',
        component: () => import('@/views/steel/twoPage/forecast')
    },
    {
        path: 'steel/map',
        name: '钢铁地图',
        component: () => import('@/views/coal/detail/map.vue')
    },
]
export default routes
